import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner,
} from "reactstrap";

const DeleteDialog = ({
  isOpen,
  title = "Confirm Deletion",
  message = "Are you sure you want to delete this item?",
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  confirmColor = "danger",
  onConfirm,
  onCancel,
  loading = false,
  disabled = false,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={!loading ? onCancel : undefined} className="modal-fixed-header-footer">
      <ModalHeader toggle={!loading ? onCancel : undefined}>{title}</ModalHeader>
      <ModalBody>
        <div className="d-flex align-items-center">
          <div className="flex-grow-1">
            <p className="text-muted mb-0" style={{ fontSize: "15px" }}>
              {message}
            </p>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          color="secondary"
          onClick={onCancel}
          disabled={loading || disabled}
          style={{
            minWidth: "90px",
            borderRadius: "8px",
            fontWeight: "500",
          }}
        >
          {cancelLabel}
        </Button>
        <Button
          color={confirmColor}
          onClick={onConfirm}
          disabled={loading || disabled}
          style={{
            minWidth: "90px",
            borderRadius: "8px",
            fontWeight: "500",
          }}
        >
          {loading ? (
            <>
              <Spinner size="sm" className="me-2" />
              Deleting...
            </>
          ) : (
            confirmLabel
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteDialog;